import React from 'react';

import type { AnimationItem } from 'lottie-web';

const FAMILY_LOOP_GAP_FRAMES = 16;
const FAMILY_LOOP_BOUNCE_FRAMES = 38;
const FAMILY_LOOP_FRAMES = FAMILY_LOOP_GAP_FRAMES + FAMILY_LOOP_BOUNCE_FRAMES;
const FAMILY_LOOP_VARIATIONS = 3;
const FAMILY_LOOP_ALL_FRAMES = FAMILY_LOOP_FRAMES * FAMILY_LOOP_VARIATIONS;
const FAMILY_READY_FRAMES = 58;

interface UseFamilyAnimation {
  lottieRef: AnimationItem | undefined;
  isBouncingRef: React.RefObject<boolean>;
}

export default function useFamilyAnimation({ lottieRef, isBouncingRef }: UseFamilyAnimation): void {
  React.useEffect(() => {
    if (lottieRef == null) return;

    const frameHandler = (): void => {
      const currentFrame = Math.floor(lottieRef.currentFrame);
      if (isBouncingRef.current) {
        if (currentFrame >= FAMILY_LOOP_ALL_FRAMES) {
          lottieRef.goToAndPlay(0, true);
        }
      } else if (currentFrame < FAMILY_LOOP_ALL_FRAMES && currentFrame % FAMILY_LOOP_FRAMES < FAMILY_LOOP_GAP_FRAMES) {
        lottieRef.goToAndPlay(FAMILY_LOOP_ALL_FRAMES + 1, true);
      } else if (currentFrame >= lottieRef.totalFrames - 1) {
        lottieRef.goToAndPlay(FAMILY_LOOP_ALL_FRAMES + FAMILY_READY_FRAMES, true);
      }
    };

    lottieRef.addEventListener('enterFrame', frameHandler);

    return (): void => {
      lottieRef.removeEventListener('enterFrame', frameHandler);
    };
  }, [lottieRef, isBouncingRef.current]);
}
